


















import {userStore} from '@/store'
import {ref, reactive, computed, defineComponent, watchEffect, onMounted} from '@vue/composition-api'

export default defineComponent({
  name: 'CamTrackIndicator',
  props: {
  },
  setup(props, context) {
    const followingCamera = computed(() => userStore.profile?.ui.shotDesigner.followCameraTrackMode || false)
    const isHighlighted = ref(false)

    const message = computed(() => {
      return followingCamera.value ?
        'View: Following Camera Track' :
        'View: Free Orbit Mode'
    })
    const tooltip = computed(() => {
      return followingCamera.value ?
        'Switch to orbit mode to allow mouse control' :
        'Switch to camera-track mode to see camera animation'
    })


    function highlight(time=250) {
      isHighlighted.value = true
      setTimeout(() => isHighlighted.value = false,
                 time)
    }

    function switchMode() {
      console.log(`switchMode(${followingCamera.value})`)
      if (userStore.profile)
        userStore.setFollowCameraTrack(!(followingCamera.value))
    }

    return {followingCamera, message, isHighlighted, tooltip, switchMode, highlight}
  }
})
